import { Button, Center, Group, Modal, Switch, Text, TextInput, Tooltip } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { IconEdit, IconTrash } from '@tabler/icons-react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import React, { useState } from 'react'
import { deleteTypeOfMonths, updateStatusTypeOfMonths } from '../../../../../api/agencyAdmin/bonus';

import { successNotification } from '../../../../../utility/notification';
import classes from '../TypeOfMonths.module.css';
import { useForm } from '@mantine/form';
import useCreate from './useCreate';

function ActionCell({ row, queryKey }) {
    const [isSwitchOn, setIsSwitchOn] = useState(row.active);
    const [opened, { open, close }] = useDisclosure(false);
    const [deleteDialogOpened, { open: openDeleteDialog, close: closeDeleteDialog }] = useDisclosure(false);
    const [editOpened, { open: openEditDialog, close: closeEditDialog }] = useDisclosure(false);

    const handleSwitchChange = () => {

        close();
        setIsSwitchOn(!isSwitchOn)

    };

    const { isPending, mutate } = useMutation({
        mutationFn: updateStatusTypeOfMonths,
        onSuccess: (res) => {
            successNotification({
                message: res?.message
            });
            handleSwitchChange()
        }
    })
    const queryclient = useQueryClient()
    const { isDeletePending, mutate: mutateDelete } = useMutation({
        mutationFn: deleteTypeOfMonths,
        onSuccess: async (res) => {
            await queryclient.invalidateQueries({
                queryKey
            })

            successNotification({
                message: res?.message
            });


            handleDeleteChange()
        }
    })



    const handleDeleteChange = () => {

        closeDeleteDialog();

    };

    const handleEditChange = () => {

        closeEditDialog();


    };

    const {
        createMutation
    } = useCreate(queryKey)

    const form = useForm({
        mode: 'uncontrolled',
        initialValues: {
            name: row?.name ?? "",
            id: row?.id

        },

    });



    const handleEdit = form.onSubmit(async (values) => {
        const formData = new FormData();
        formData.append("name", values?.name);
        formData.append("id", values?.id);
        createMutation.mutate(formData)
        closeEditDialog();

    });

    return (
        <>
            <Group justify="center" p="md">
                {/* Switch for activating/inactivating user */}
                <Switch
                    type="checkbox"
                    checked={isSwitchOn}
                    onChange={open}
                />

                <div className={classes.icon_button_primary}>
                    <Tooltip label="Edit">
                        <IconEdit
                            style={{ color: 'white', fontSize: '20px', alignItems: 'center' }}
                            onClick={openEditDialog}
                        >

                        </IconEdit>
                    </Tooltip>
                </div>


                <div className={classes.icon_button_danger}>
                    <Tooltip label="Delete">
                        <IconTrash
                            style={{ color: 'white', fontSize: '20px', alignItems: 'center' }}
                            onClick={openDeleteDialog}
                        >

                        </IconTrash>
                    </Tooltip>
                </div>





                {/* Modal for activation/inactivation confirmation */}
                <Modal opened={opened} onClose={close} centered title="Confirm">
                    <Text>
                        Are you sure you want to {!isSwitchOn ? 'Activate' : 'Inactive'} the type of month?
                    </Text>
                    <Center mt="md">
                        <Button
                            variant="gradient"
                            gradient={{ from: '#44FFFA', to: '#FF4267', deg: 90 }}
                            onClick={() => mutate({
                                id: row?.id,
                                status: !isSwitchOn,
                            })}
                            loading={isPending}
                        >
                            Confirm
                        </Button>
                    </Center>
                </Modal>

                {/* Modal for deleting agency code */}
                <Modal opened={deleteDialogOpened} onClose={closeDeleteDialog} centered title="Delete Confirmation">
                    <Text>Are you sure you want delete this type of month?</Text>
                    <Center mt="md">
                        <Button
                            variant="gradient"
                            gradient={{ from: '#44FFFA', to: '#FF4267', deg: 90 }}
                            onClick={() => mutateDelete({ id: row?.id })}
                            loading={isDeletePending}
                        >
                            Confirm
                        </Button>
                    </Center>
                </Modal>

                <Modal opened={editOpened} onClose={closeEditDialog} centered title="Edit Type of Month">
                    <TextInput
                        label="Name"
                        placeholder="Enter Name"
                        key={form.key('name')}
                        style={{ alignSelf: "baseline" }}
                        {...form.getInputProps('name')}
                    />

                    <Center mt={"md"}>
                        <Button onClick={() => handleEdit()}>
                            Save
                        </Button>
                    </Center>
                </Modal>
            </Group>
        </>
    )
}

export default ActionCell
